import { render } from "./Main.vue?vue&type=template&id=5edb9656"
const script = {}
script.render = render

export default script